module.exports = __webpack_public_path__ + "static/media/ic_check_filled copy.7101e451.svg";